// ========================== custom product js ========================== 
  var textColor = '#000000';
  var backgroundColor = '#000000';
  const colorpicker = new dhx.Colorpicker("colorpicker", {
      css: "custom-color-picker dhx_widget--bordered",
      pickerOnly: true
  });
  
  const colorExample = document.querySelector(".dhx_color-sample");
  colorpicker.events.on("change", function (color) {
      colorExample.style.backgroundColor = color;
      backgroundColor = color;
      loadonBottle();
  });
  
  colorpicker.setValue("#000000");

  colorpicker.events.on("apply", function(e) {
      $(".dhx_colorpicker-picker__buttons").parents(".color_popup_wrapper").removeClass("active");
      $("body").removeClass("cc-popup-no-scroll");
  });

  const colorpicker2 = new dhx.Colorpicker("textcolorpicker", {
      css: "custom-color-picker dhx_widget--bordered",
      pickerOnly: true
  });
  
  const colorExampletext = document.querySelector(".dhx_color-sample-text");
  colorpicker2.events.on("change", function (color) {
      colorExampletext.style.backgroundColor = color;
      textColor = color;
      if (nameInput != undefined) { 
        nameInput.fill = textColor;
        id = $(".product-input-wrapper .name-input").attr('id');
        newtext = $(".product-input-wrapper .name-input").val();
        input = $(".product-input-wrapper .name-input");
        objs = canvasP.getObjects();
        objs.forEach(function(obj,value) {
          if (obj && obj.id == id) {
            setTimeout(function(){
              obj.setText(newtext);
              canvasP.renderAll();
              input.attr("data-text", newtext);
            },200);
          }
        });
        canvasP.renderAll();
      }
      loadonBottle();
  });
  
  colorpicker2.setValue("#000000");

  colorpicker2.events.on("apply", function(e) {
      $(".dhx_colorpicker-picker__buttons").parents(".color_popup_wrapper").removeClass("active");
      $("body").removeClass("cc-popup-no-scroll");
  });

  $(".color_open_btn").click(function() {
      $(this).parents(".color-wrapper").find(".color_popup_wrapper").addClass("active");
      $("body").addClass("cc-popup-no-scroll");
  })

  $("#unique-name-checkbox").click(function() {
      $(this).parents(".checkbox-wrapper").find(".color_popup_wrapper").addClass("active");
      $("body").addClass("cc-popup-no-scroll");
      $(this).prop("checked", true);
  });
  $(".contact-form-trigger,.customize_product_wrapper a[href='#open_form']").click(function(e) {
      e.preventDefault();
      $("body").addClass("cc-popup-no-scroll");
      $(".form_popup").addClass("active");
  });
  $(document).mouseup(function (e) {
      var popup = $("#colorpicker, #textcolorpicker,.has_checkbox,.form_popup form");
      if (!popup.is(e.target) && popup.has(e.target).length === 0) {
          $(".dhx_colorpicker-picker__buttons").parents(".color_popup_wrapper").removeClass("active");
          $("body").removeClass("cc-popup-no-scroll");
          $(".form_popup").removeClass("active");
      }
  });
  $(".color_popup_wrapper .close_btn_form").click(function () {
      $(this).parents(".active").removeClass("active");
      setHiidenName();
      if ($(".all_unique_input").val() != "") {
        $(this).parents(".color_popup_wrapper").addClass("has_multipal_value");
      }else {
        $(this).parents(".color_popup_wrapper").removeClass("has_multipal_value");      
      }
      $("body").removeClass("cc-popup-no-scroll");
      $(this).parents(".color_popup_wrapper").removeClass("active");
      if(!$(this).parents(".color_popup_wrapper").hasClass("has_multipal_value")){
        $("#unique-name-checkbox").prop("checked", false);
      }
  })

  $(".close_btn_form").click(function (e) {
      $("body").removeClass("cc-popup-no-scroll");
      $(".form_popup").removeClass("active");
  });

  $(".customize_main_wrapper.customize_product_wrapper .multipal_names_submit").click(function() {
    setHiidenName();
    if ($(".all_unique_input").val() != "") {
      $(this).parents(".color_popup_wrapper").addClass("has_multipal_value");
    }else {
      $(this).parents(".color_popup_wrapper").removeClass("has_multipal_value");      
    }
    $("body").removeClass("cc-popup-no-scroll");
    $(this).parents(".color_popup_wrapper").removeClass("active");
    if(!$(this).parents(".color_popup_wrapper").hasClass("has_multipal_value")){
      $("#unique-name-checkbox").prop("checked", false);
    }
  });

  function setHiidenName() {
    var nameArry = "";
    var nameArryMain = [];
    $(".customize_main_wrapper.customize_product_wrapper .name_input_wrapper li input").each(function(index) {
       var inputValue = $(this).val();
      if (inputValue.trim() !== "") {
          nameArry += inputValue;
          nameArryMain.push(inputValue);
          if (index < $(".customize_main_wrapper.customize_product_wrapper .name_input_wrapper li input").length - 1) {
              nameArry += ",";
          }
      }
    });
    $(".customize_main_wrapper .customize_map_wrapper .left_sidebar .map_qty_btn_wrapper input").val(nameArryMain.length);
    $(".all_unique_input").val(nameArry);
  }

  $(".add_more_name").click(function(){
    $(this).parents(".name_popup_wrapper").find(".name_input_wrapper").append('<li class="input_wrapper"><input type="text" class="name_input_element" placeholder="Type naam of tekst" data-target="all_unique_input"></li>')
    var myDiv = document.querySelector(".name_input_wrapper");
    myDiv.scrollTop = myDiv.scrollHeight;
  })

  var inputs = document.querySelectorAll('.custom-image-uploader-wrapper')

  for (var i = 0, len = inputs.length; i < len; i++) {
    customInput(inputs[i])
  }
  
  function customInput (el) {
    const fileInput = el.querySelector('[type="file"]')
    const label = el.querySelector('[data-js-label]')
    
    fileInput.onchange  = function () {
      if (!fileInput.value) return
      
      var value = fileInput.value.replace(/^.*[\\\/]/, '')
      label.innerText = value
    }
  }

  var mapcanvas = this.__canvas = new fabric.Canvas('map_product_canvas');
  var mapctx = mapcanvas.getContext('2d');

  var canvasP = this.__canvas = new fabric.Canvas('preview_canvas_product');
  var ctxP = canvasP.getContext('2d');

   canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width());
   canvasP.setHeight($(".customize_map_wrapper .product_image_preview_wrapper .rimage-outer-wrapper").height()/ 1.17); 

  const fileInput = document.querySelector(".image_uploader");
  const fileInput2 = document.querySelector(".image_uploader_2");

  function handleFileUpload(id,thisInput,topToSet) {    
    const fileReader = new FileReader();
    var fileInput = thisInput.files[0];
    if (fileInput){
      
      fileReader.readAsDataURL(thisInput.files[0])
      fileReader.onload = (e) => {
        const dataURL = e.target.result;
        $(thisInput).parents(".custom-image-uploader-wrapper").find('input[type="hidden"]').val(dataURL);
        
        var getId = id;
        var objlength = canvasP.getObjects();
        if(objlength.length != 0){
          objs = canvasP.getObjects();
          objs.forEach(function(obj,value) {
            if (obj && obj.id == getId) {
              setTimeout(function(){
                canvasP.remove(obj).renderAll();
              },200);
            }
          });
          canvasP.renderAll();
        }
        
          fabric.Image.fromURL(dataURL, function(img) {
            var oImg = img.set({
              id: id,
              left: canvasP.width / 2 - canvasP.width / 5,
              top: topToSet,
              cornerSize: 20,
            },{
              crossOrigin: 'anonymous'
            }).setCoords();
            oImg.scaleToWidth(canvasP.width / 2.5);
            canvasP.add(oImg).renderAll();
            canvasP.sendToBack(oImg);
            canvasP.bringToFront(oImg);
            var objle = canvasP.getObjects();
            
            canvasP.setActiveObject(canvasP.item(objle.length - 1));
          });
          
      }
    }

  }

  fileInput.addEventListener('change',function() { 
    handleFileUpload("uplodimge1",this,canvasP.height / 5 );
  });

  fileInput2.addEventListener('change', function(){
    handleFileUpload("uplodimge2",this,canvasP.height / 3.5 );
  });

$(".customize_main_wrapper.customize_product_wrapper .leftside_main_step_container .custom-image-uploader-wrapper .remove_image").click(function() {
    var getId = $(this).parents(".custom-image-uploader-wrapper").find("input[type='file']").attr("data-target");
    var objlength = canvasP.getObjects();
    if(objlength.length != 0){
      objs = canvasP.getObjects();
      objs.forEach(function(obj,value) {
        if (obj && obj.id == getId) {
          setTimeout(function(){
            canvasP.remove(obj).renderAll();
          },200);
        }
      });
      canvasP.renderAll();
    }
    $(this).parents(".custom-image-uploader-wrapper").find(".image_uploader_value").val("");
    $(this).parents(".custom-image-uploader-wrapper").find(".label").text($(this).parents(".custom-image-uploader-wrapper ").find(".label").attr("data-blank-label"))
    loadonBottle();
})



// ========================== custom events ==========================



  let lang_lat_textvwFontSize = canvasP.width * 0.070;
  let allFontWidthVh = canvasP.width * 0.350;
  let allFontleft = canvasP.width / 2 - nameInput?.width / 1.5;
  var nameInput = new fabric.Textbox("Text", {
    id: "nameinput",
    selectable: false,
    fill: textColor,
    fontStyle: 'normal',
    fontWeight: 500,
    text: '',
    textAlign: 'center',
    fontFamily: "Montserrat,sans-serif",
    top: canvasP.height / 1.23,
    left: allFontleft,
    fontSize: lang_lat_textvwFontSize,
    evented: true,
    staticfontSize:10
  });
  canvasP.add(nameInput);
  canvasP.sendToBack(nameInput);



  var sizePercentage = 0.07;
  $(".font-size-btn").click(function() {
      var getTargetSize = $(this).attr("data-target");
      var sizeChange = 0.010;
  
      if (getTargetSize == 'plus') {
          sizePercentage += sizeChange;
      } else {
          sizePercentage -= sizeChange;
      }

      nameInput.left = canvasP.width / 2 -  nameInput.width / 2;
      nameInput.fontSize = canvasP.width * sizePercentage
      id = $(".product-input-wrapper .name-input").attr('id');
      newtext = $(".product-input-wrapper .name-input").val();
      input = $(".product-input-wrapper .name-input");
      objs = canvasP.getObjects();
      objs.forEach(function(obj,value) {
        if (obj && obj.id == id) {
          setTimeout(function(){
            obj.setText(newtext).bringToFront(obj);
            canvasP.renderAll();
            input.attr("data-text", newtext);
          },200);
        }
      });
      canvasP.renderAll();
      loadonBottle();
  });

  $(".product-input-wrapper .name-input").keyup(function() {
    var bottleType = $('.custom-map-collection-tab-wrapper .collection-map-tab.is-active').attr('data-tab');
    // console.log(bottleType,'bottleType');
    nameInput.fill = textColor;
    if(bottleType == 'bottle'){
      nameInput.left = canvasP.width / 2 -  nameInput.width / 2;
    }else if(bottleType == 'mug'){
      nameInput.left = canvasP.width / 1.85 -  nameInput.width / 2;
    }
    id = $(this).attr('id');
    newtext = $(this).val();
    input = $(this);
    objs = canvasP.getObjects();
    
    objs.forEach(function(obj,value) {
      if (obj && obj.id == id) {
        setTimeout(function(){
          obj.setText(newtext).bringToFront(obj);
          canvasP.renderAll();
          input.attr("data-text", newtext);
        },200);
      }
    });
    setTimeout(() => {
        var getshapBack = mapcanvas.getObjects();
        getshapBack.forEach(function(items){
            if (items.id == 'shape') {
                if (items.id == 'shape') {
                      mapcanvas.sendToBack(items);   
                }
            }
        });
    },200);
    canvasP.renderAll();
    loadonBottle();
  });

const alignCenter = true;

  var currentimage;
  function loadonBottle() {
    bottleonShape($(".customize_main_wrapper.customize_product_wrapper .leftside_main_step_container .style-btn.active").attr('data-label'),$(".customize_main_wrapper.customize_product_wrapper .leftside_main_step_container .style-btn.active").attr('data-type'));
    var bottlyType = $(".customize_main_wrapper.customize_product_wrapper .leftside_main_step_container .style-btn.active").attr('data-type');
    if (canvasP != undefined) {
      canvasP.deactivateAll();
      var getshapBack = canvasP.getObjects();
      getshapBack.forEach(function(items){
        if (items.id == 'nameinput') {
          canvasP.bringToFront(items);   
        }
      });
    }
    setTimeout(() => {
      const mapdataURL = canvasP.toDataURL();

      if (currentimage) {
        mapcanvas.remove(currentimage);
      }

      if(bottlyType == 'bottle'){
        var leftImageSet = mapcanvas.width / 2.43;
        if (window.innerWidth <= 749) {
          leftImageSet = mapcanvas.width / 2.45;        
        }else if (window.innerWidth <= 991) {
          leftImageSet = mapcanvas.width / 2.43;
        }
        var imagewidth = mapcanvas.width / 2.835;        
        if (window.innerWidth <= 749) {
          imagewidth = mapcanvas.width / 2.85;        
        }
        var imageheight = mapcanvas.height / 1.13;
        var topImageSet = mapcanvas.height / 8.8;
      }else if(bottlyType == 'mug'){
        var leftImageSet = mapcanvas.width / 2.55;
        if (window.innerWidth <= 749) {
          leftImageSet = mapcanvas.width / 2.575;        
        }else if (window.innerWidth <= 991) {
          leftImageSet = mapcanvas.width / 2.55;
        }
        var imagewidth = mapcanvas.width / 1.96;        
        if (window.innerWidth <= 749) {
          imagewidth = mapcanvas.width / 1.957;        
        }
        var imageheight = mapcanvas.height / 1.5; 
        var topImageSet = mapcanvas.height / 2.5;
      }

      
      
      // console.log(mapcanvas.width,imagewidth,mapcanvas.height,imageheight,'imageheight inn');
      
      var slotRec = new fabric.Rect({
        originX: 'left', 
        originY: 'top',
        left: leftImageSet, 
        top: topImageSet,
        width: imagewidth, 
        height: imageheight,
        fill: 'transparent',
        borderColor: "transparent",
        selectable: false
      });
      
      fabric.Image.fromURL(mapdataURL, function(img) {
         currentimage = img;
       var oImg = img.set({
        id: 'test',
        left: mapcanvas.width / 4,
        top:  mapcanvas.height / 2,
        cornerSize: 0,
        hasBorders: false,
        opacity: 1,
         clipTo: function(ctx) {
          return clipBySlot(ctx, img, slotRec);	 
         }
      },{
        crossOrigin: 'anonymous'
      });
      oImg.scaleToWidth(mapcanvas.width / 1.9);
      oImg.scaleToHeight(mapcanvas.height / 1.55); 
      
      scaleImageToSlot(img, slotRec);
      mapcanvas.add(oImg).renderAll();
      // mapcanvas.sendToBack(oImg);
      var objle = mapcanvas.getObjects();
      mapcanvas.setActiveObject(mapcanvas.item(objle.length - 1));
      });

      // setTimeout(() => {
        var getshapBack = mapcanvas.getObjects();
        getshapBack.forEach(function(items){
            if (items.id == 'shape') {
                if (items.id == 'shape') {
                      mapcanvas.sendToBack(items);   
                }
            }
        });
      // },200)
      
    },500)
  }


function scaleImageToSlot(image, slot) {
  
  let ratio = Math.min(slot.width / image.width, slot.height / image.height);
  
  if(ratio <= 1) {
    image.scaleToWidth(slot.width);
    let newHeight = image.height * image.scaleY;
    
    if(newHeight < slot.height) {
      image.scaleToHeight(slot.height);
    }
  }
  else {
    image.scaleToHeight(slot.height);
    let newWidth = image.width * image.scaleX;
    
    if(newWidth < slot.width) {
      image.scaleToWidth(slot.width);
    }
  }
  
  var shiftLeft = (slot.width - (image.width*image.scaleX)) / 2;
  var shiftTop = (slot.height - (image.height*image.scaleY)) / 2;
  
  if(alignCenter) {
    image.setLeft(slot.left + shiftLeft);
    image.setTop(slot.top + shiftTop);
  }
  else {
    if(image.left < slot.left) {
      image.setLeft(slot.left);
    }
    if(image.top < slot.top) {
      image.setTop(slot.top);
    }    
  }
  
}

function clipBySlot(ctx, image, slot) {
  var scaleXTo1 = (1 / image.scaleX);
  var scaleYTo1 = (1 / image.scaleY);
  
  ctx.save();
  
  ctx.translate(0, 0);
  ctx.rotate(degToRad(image.angle * -1));
  ctx.scale(scaleXTo1, scaleYTo1);
  
  ctx.beginPath();
  
  const boundingRect = image.getBoundingRect();
  ctx.rect(
    slot.left - image.left - Math.floor(boundingRect.width / 2),
    slot.top - image.top - Math.floor(boundingRect.height / 2),
    slot.width,
    slot.height
  );
  ctx.closePath();
  
  ctx.restore();
}

function degToRad(degrees) {
  return degrees * (Math.PI / 180);
}


  var canvasModifiedCallback = function() {
    loadonBottle();
  };
  
  canvasP.on('object:added', canvasModifiedCallback);
  canvasP.on('object:removed', canvasModifiedCallback);
  canvasP.on('object:modified', canvasModifiedCallback);


  $(".customize_map_wrapper .leftside_main_step_container .custom-map-collection-tab-content-product-image").click(function(e) {
      e.preventDefault();
      $(".customize_map_wrapper .leftside_main_step_container .custom-map-collection-tab-content-product-image").removeClass("selected_product");
      $(this).addClass("selected_product");
      var getVariantId = $(this).attr("data-id");
      var getVariantPrice = $(this).attr("data-price");
      $('.customize_map_wrapper .step-item-wrapper button.product_buy_btn').attr("data-variant-id" , getVariantId);
      $('.customize_map_wrapper .step-item-wrapper .product_price').html(theme.Shopify.formatMoney(getVariantPrice, theme.money_format));
          var getImageLink = $(this).attr('data-set-defaultimage');
          var getImageoverlayLink = $(this).attr('data-set-overlayImage');
      $(".customize_map_wrapper .main_contains_wrapper").css("--custom-background-color", $(this).data('bg-color'));
      var getActiveProduct = $(".customize_map_wrapper .leftside_main_step_container .collection-map-tab.is-active").data("tab");
      setProductImage(getImageLink,getImageoverlayLink,getActiveProduct);
      
    
      if (getActiveProduct == "mug") {

        // canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() / 1.15);
        // canvasP.setHeight($(".customize_map_wrapper .product_image_preview_wrapper .canvas-container.added_canvas").height() / 1.7);
  
        // if(window.innerWidth <= 424){
        //   canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() / 1.44);
        // }else if(window.innerWidth <= 480){
        //   canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() / 1.35);
        // }else if(window.innerWidth <= 580){
        //   canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() / 1.27);
        // }else if(window.innerWidth <= 680){
        //   canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() / 1.22);
        // }else if (window.innerWidth <= 749) {
        //   canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() / 1.19);
        // }
  
        
        // $('.customize_map_wrapper').addClass('mug_map');
        // $('.customize_map_wrapper').removeClass('bottle_map');
        // var getCanvasHeight = $('.main_contains_wrapper').height();
        // var getMapCanvasHeight = $('.main_contains_wrapper .customize_preview_wrapper .canvas-container').height();
        // var canvasMinusHeight = getCanvasHeight - (getMapCanvasHeight + 100);
        // var canvasSetHeight = getCanvasHeight - canvasMinusHeight;
        // $('.main_contains_wrapper').css({
        //     "margin-top": "-" + canvasMinusHeight + "px"
        // });
        // nameInput.left = canvasP.width / 1.8 - nameInput?.width / 1.5;
        // nameInput.top = canvasP.height / 1.5;
        // nameInput.width = canvasP.width / 2.26;
      
      
    }else if (getActiveProduct == "bottle"){
      $('.main_contains_wrapper').css({
          "margin-top": 50 + "px"
      });
        canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() * 1.15);
        canvasP.setHeight($(".customize_map_wrapper .product_image_preview_wrapper .canvas-container.added_canvas").height() / 1.17);

        if(window.innerWidth <= 424){
          canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() * 1.44);
        }else if(window.innerWidth <= 480){
          canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() * 1.35);
        }else if(window.innerWidth <= 580){
          canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() * 1.27);
        }else if(window.innerWidth <= 680){
          canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() * 1.22);
        }else if (window.innerWidth <= 749) {
          canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() * 1.19);
        }

        nameInput.left = canvasP.width * 1.8 - nameInput?.width * 1.5;
        nameInput.top = canvasP.height / 1.23;

        $('.customize_map_wrapper').removeClass('mug_map');
        $('.customize_map_wrapper').addClass('bottle_map');
        var getCanvasHeight = $('.main_contains_wrapper').height();
        var getMapCanvasHeight = $('.main_contains_wrapper .customize_preview_wrapper .canvas-container').height();
        var canvasMinusHeight = getCanvasHeight - getMapCanvasHeight;
        var canvasSetHeight = getCanvasHeight - canvasMinusHeight;
    }
      loadonBottle();        
  })

  $(".customize_map_wrapper .leftside_main_step_container .collection-map-tab").click(function() {

    $(".customize_map_wrapper .leftside_main_step_container .collection-map-tab").removeClass("is-active");
    $(this).addClass("is-active");
    var getSlectorDiv = $(this).data("tab");
    $(".custom-map-collection-tab-content-wrapper .custom-map-collection-tab-content").removeClass("is-active");
    $("#"+getSlectorDiv).addClass("is-active");
    $(".custom-label-type").text($(this).data('label'));
    
    var getImageLink = $(this).attr('data-set-defaultimage');
    var getImageoverlayLink = $(this).attr('data-set-overlayImage');
    var getTab = $(this).attr('data-tab');
    var getImageWrapper = $('.product_customized_preview .added_canvas .rimage__image');
    $(getImageWrapper).attr("data-srcset",getImageLink);
    $(getImageWrapper).attr("srcset",getImageLink);
    setProductImage(getImageLink,getImageoverlayLink,getTab);
    var getColorType = $('.custom-map-collection-tab-content-product .custom-map-collection-tab-content-product-image.selected_product').attr('data-index');
    $('.custom-map-collection-tab-content.is-active .custom-map-collection-tab-content-product-image').each(function(){
      var allIndex = $(this).attr('data-index');
      if(getColorType == allIndex){
        $(this).trigger('click');
        $(this).addClass('selected_product');
      }else{
        $(this).removeClass('selected_product');
      }
    });

    $('.style-btn-wrapper .style-btn').each(function(){
      $(this).attr("data-type",getTab);
    });
    if (getSlectorDiv == "mug") {

        canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() / 1.15);
        canvasP.setHeight($(".customize_map_wrapper .product_image_preview_wrapper .canvas-container.added_canvas").height() / 1.7);
  
        if(window.innerWidth <= 424){
          canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() / 1.44);
        }else if(window.innerWidth <= 480){
          canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() / 1.35);
        }else if(window.innerWidth <= 580){
          canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() / 1.27);
        }else if(window.innerWidth <= 680){
          canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() / 1.22);
        }else if (window.innerWidth <= 749) {
          canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() / 1.19);
        }
  
        
        $('.customize_map_wrapper').addClass('mug_map');
        $('.customize_map_wrapper').removeClass('bottle_map');
        var getCanvasHeight = $('.main_contains_wrapper').height();
        var getMapCanvasHeight = $('.main_contains_wrapper .customize_preview_wrapper .canvas-container').height();
        var canvasMinusHeight = getCanvasHeight - (getMapCanvasHeight + 100);
        var canvasSetHeight = getCanvasHeight - canvasMinusHeight;
        $('.main_contains_wrapper').css({
            "margin-top": "-" + canvasMinusHeight + "px"
        });
        nameInput.left = canvasP.width / 1.8 - nameInput?.width / 1.5;
        nameInput.top = canvasP.height / 1.5;
        nameInput.width = canvasP.width / 2.26;
        loadonBottle();        

      
      
    }else if (getSlectorDiv == "bottle"){
      $('.main_contains_wrapper').css({
          "margin-top": 50 + "px"
      });
        canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() * 1.15);
        canvasP.setHeight($(".customize_map_wrapper .product_image_preview_wrapper .canvas-container.added_canvas").height() / 1.17);

        if(window.innerWidth <= 424){
          canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() * 1.44);
        }else if(window.innerWidth <= 480){
          canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() * 1.35);
        }else if(window.innerWidth <= 580){
          canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() * 1.27);
        }else if(window.innerWidth <= 680){
          canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() * 1.22);
        }else if (window.innerWidth <= 749) {
          canvasP.setWidth($(".customize_map_wrapper .frame-wrapper").width() * 1.19);
        }

        nameInput.left = canvasP.width * 1.8 - nameInput?.width * 1.5;
        nameInput.top = canvasP.height / 1.23;
        loadonBottle();        

        $('.customize_map_wrapper').removeClass('mug_map');
        $('.customize_map_wrapper').addClass('bottle_map');
        var getCanvasHeight = $('.main_contains_wrapper').height();
        var getMapCanvasHeight = $('.main_contains_wrapper .customize_preview_wrapper .canvas-container').height();
        var canvasMinusHeight = getCanvasHeight - getMapCanvasHeight;
        var canvasSetHeight = getCanvasHeight - canvasMinusHeight;
    }
    

  })

  $(".map_qty_btn[data-type='decrease']").click(function() {
    var currentQuantity = parseInt($(this).parents().find(".qty_input").val(), 10);
    if (currentQuantity > 30) {
      $(this).parents().find(".qty_input").val(currentQuantity - 1);
    }
  });
    
  $(".map_qty_btn[data-type='increase']").click(function() {
    var currentQuantity = parseInt($(this).parents().find(".qty_input").val(), 10);
    $(this).parents().find(".qty_input").val(currentQuantity + 1);
  });

// ========================= custom shape ============================
  var currentShape;
  function bottleonShape(shape, type) { 
    // console.log(shape,'shape',type);
    setTimeout(() => {

      let bottleShapeWidth;
      if(type == 'bottle'){
         bottleShapeWidth = mapcanvas.width / 2.75;
        if (window.innerWidth <= 480) {
           bottleShapeWidth = mapcanvas.width / 2.8;
        }
      }else if(type == 'mug'){
         bottleShapeWidth = mapcanvas.width / 2.22;
        if (window.innerWidth <= 480) {
           bottleShapeWidth = mapcanvas.width / 2.24;
        }
      }
      

      console.log(bottleShapeWidth,'bottleShapeWidth',mapcanvas.width,mapcanvas.height);
      
      if(type == 'bottle'){
        if (shape == 'none') {
          var startPoints = [];
        }else if (shape == "schuine-streep") {
          var startPoints = [
            {x: 0, y: 0},
            {x: bottleShapeWidth, y: 0},
            {x: bottleShapeWidth, y: mapcanvas.height / 3.3},
            {x: 0, y: mapcanvas.height / 1.8}
          ];
        }else if (shape == "half") {
          var startPoints = [
            {x: 0, y: 0},
            {x: bottleShapeWidth, y: 0},
            {x: bottleShapeWidth, y: mapcanvas.height / 2.2},
            {x: 0, y: mapcanvas.height / 2.2}
          ];
        }else if (shape == "gradient-up") {
          var startPoints = [
            {x: 0, y: 0},
            {x: bottleShapeWidth, y: 0},
            {x: bottleShapeWidth, y: mapcanvas.height / 1.1},
            {x: 0, y: mapcanvas.height / 1.1}
          ];
        }else if (shape == "gradient-down") {
          var startPoints = [
            {x: 0, y: 0},
            {x: bottleShapeWidth, y: 0},
            {x: bottleShapeWidth, y: mapcanvas.height / 1.05},
            {x: 0, y: mapcanvas.height / 1.05}
          ];
        }else if (shape == "full-color") {
          var startPoints = [
            {x: 0, y: 0},
            {x: bottleShapeWidth, y: 0},
            {x: bottleShapeWidth, y: mapcanvas.height},
            {x: 0, y: mapcanvas.height}
          ];
        }
      }else if(type == 'mug'){
        if (shape == 'none') {
          var startPoints = [];
        }else if (shape == "schuine-streep") {
          var startPoints = [
            {x: 0, y: 0},
            {x: bottleShapeWidth, y: 0},
            {x: bottleShapeWidth, y: mapcanvas.height / 5.7},
            {x: 0, y: mapcanvas.height / 2.5}
          ];
        }else if (shape == "half") {
          var startPoints = [
            {x: 0, y: 0},
            {x: bottleShapeWidth, y: 0},
            {x: bottleShapeWidth, y: mapcanvas.height / 3.4},
            {x: 0, y: mapcanvas.height / 3.4}
          ];
        }else if (shape == "gradient-up") {
          var startPoints = [
            {x: 0, y: 0},
            {x: bottleShapeWidth, y: 0},
            {x: bottleShapeWidth, y: mapcanvas.height / 1.65},
            {x: 0, y: mapcanvas.height / 1.65}
          ];
        }else if (shape == "gradient-down") {
          var startPoints = [
            {x: 0, y: 0},
            {x: bottleShapeWidth, y: 0},
            {x: bottleShapeWidth, y: mapcanvas.height / 1.65},
            {x: 0, y: mapcanvas.height / 1.65}
          ];
        }else if (shape == "full-color") {
          var startPoints = [
            {x: 0, y: 0},
            {x: bottleShapeWidth, y: 0},
            {x: bottleShapeWidth, y: mapcanvas.height / 1.65},
            {x: 0, y: mapcanvas.height / 1.65}
          ];
        }
      }


      
      if (currentShape) {
        mapcanvas.remove(currentShape);
      }

        var clonedStartPoints = startPoints.map(function(o){
          return fabric.util.object.clone(o);
        });

        if(type == 'bottle'){
          var polygon = new fabric.Polygon(clonedStartPoints, {
            id: 'shape',
            originX: 'left', 
            originY: 'top',
            left: mapcanvas.width / 2.5, 
            top: mapcanvas.height / 10,
            width: mapcanvas.width / 2.65, 
            height: mapcanvas.height / 1.5,
            fill: backgroundColor,
            selectable: false,
            objectCaching: false,
            cornerSize: 0,
            globalCompositeOperation: 'multiply',
            hasBorders: false
          });
        }else if(type == 'mug'){
          // console.log(mapcanvas.width / 2.5,mapcanvas.width,)
          var polygon = new fabric.Polygon(clonedStartPoints, {
              id: 'shape',
              originX: 'left', 
              originY: 'top',
              left: mapcanvas.width / 2.22, 
              top: mapcanvas.height / 2.5,
              width: mapcanvas.width / 2.5, 
              height: mapcanvas.height / 1.5,
              fill: backgroundColor,
              selectable: false,
              objectCaching: false,
              cornerSize: 0,
              globalCompositeOperation: 'multiply',
              hasBorders: false
          });
        }

     
      if (shape == 'gradient-up') {
        polygon.setGradient('fill', {
          x1: 0,
          y1: -polygon.height,
          x2: -polygon.width,
          y2: polygon.height,
          colorStops: {
            0:backgroundColor,
            0.5: backgroundColor,
            1: "transparent"
          }
        });
      } else if (shape == "gradient-down") {
        polygon.setGradient('fill', {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: polygon.height,
          colorStops: {
            0: "transparent",
            0.95: backgroundColor,
            1: backgroundColor
          }
        });
      }
      
        currentShape = polygon;
        mapcanvas.add(polygon);
        mapcanvas.sendToBack(polygon);
        var getshapBack = mapcanvas.getObjects();
          getshapBack.forEach(function(items){
              if (items.id == 'shape') {
                  if (items.id == 'shape') {
                        mapcanvas.sendToBack(items);   
                  }
              }
          })
    },500)
  }
  bottleonShape("none", "bottle");

  $(".customize_main_wrapper.customize_product_wrapper .leftside_main_step_container .style-btn").click(function() {
    $(".customize_main_wrapper.customize_product_wrapper .leftside_main_step_container .style-btn").removeClass("active");
    $(this).addClass("active");
    bottleonShape($(this).attr('data-label'),$(this).attr('data-type'));
  })

// ========================== Product preview ==========================


  function mapCanvasResize() { 
     mapcanvas.setWidth($(".customize_map_wrapper .product_image_preview_wrapper .rimage-outer-wrapper").width());
     mapcanvas.setHeight($(".customize_map_wrapper .product_image_preview_wrapper .rimage-outer-wrapper").height());      
  }

  mapCanvasResize();

  function setProductImage(image,overlayImage,type) {
    mapcanvas.clear();
    window.fabric.Image.fromURL(image, function(img) {
      let scaleRatio;
      
      if (type !== undefined) {
        if (type == 'mug') {
          scaleRatio = Math.min( mapcanvas.height / (img.height + img.width / 1.8), mapcanvas.height / (img.height + img.width / 2));
        } else {
          scaleRatio = Math.min(mapcanvas.width / img.width, mapcanvas.height / img.height);
        }
      } else {
        scaleRatio = Math.min(mapcanvas.width / img.width, mapcanvas.height / img.height);
      }
      // console.log(type,mapcanvas.width,'--',img.width,mapcanvas.height,'===',img.height, scaleRatio,'scaleRatio 1');
      if (type == 'mug') {
        mapcanvas.setBackgroundImage(img, mapcanvas.renderAll.bind(mapcanvas), {
          left: mapcanvas.width / 2,
          top: mapcanvas.height / 1.49,
          originX:"center",
          originY:"center",
          scaleX: scaleRatio,
          scaleY: scaleRatio,
        });        
      }else{
        mapcanvas.setBackgroundImage(img, mapcanvas.renderAll.bind(mapcanvas), {
          left: mapcanvas.width / 2,
          top: mapcanvas.height / 2,
          originX:"center",
          originY:"center",
          scaleX: scaleRatio,
          scaleY: scaleRatio,
        });
      }
    });
    $(".customize_map_wrapper .product_image_preview_wrapper .rimage-outer-wrapper").addClass("added_canvas");
    $(".customize_map_wrapper .product_image_preview_wrapper .canvas-container").addClass("added_canvas");
    fabric.Image.fromURL(overlayImage, function(img) {
        let scaleRatio;
        
        if (type !== undefined) {
          if (type == 'mug') {
            scaleRatio = Math.min( mapcanvas.height / (img.height + img.width / 1.8), mapcanvas.height / (img.height + img.width / 2));
          } else {
            scaleRatio = Math.min(mapcanvas.width / img.width, mapcanvas.height / img.height);
          }
        } else {
          scaleRatio = Math.min(mapcanvas.width / img.width, mapcanvas.height / img.height);
        }
        if (type == 'mug') {
          img.set({
              scaleX: scaleRatio,
              scaleY: scaleRatio,
              left: mapcanvas.width / 2,
              top: mapcanvas.height / 1.49,
              objectCaching: false,
              originX: 'center',
              originY: 'center'
           });          
        }else{
          img.set({
              scaleX: scaleRatio,
              scaleY: scaleRatio,
              left: mapcanvas.width / 2,
              top: mapcanvas.height / 2,
              objectCaching: false,
              originX: 'center',
              originY: 'center'
           });
        }
         mapcanvas.setOverlayImage(img, mapcanvas.renderAll.bind(mapcanvas));
     });
    mapcanvas.renderAll();
  }

    var defaultImage = $(".customize_map_wrapper .leftside_main_step_container .collection-map-tab.is-active").data("set-defaultimage");
    var overlaydefaultImage = $(".customize_map_wrapper .leftside_main_step_container .collection-map-tab.is-active").data("set-overlayimage");
    setProductImage(defaultImage,overlaydefaultImage,"");
  
  

// ========================== add to cart ==========================

  function b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  $(".customize_map_wrapper .step-item-wrapper button.product_buy_btn").click(function(e) {
    var img = new Image();
    if ($(".image_uploader_value_1").val() != "") { 
      var ImageURL = $(".image_uploader_value_1").val(),
          block = ImageURL.split(";"),
          contentType = block[0].split(":")[1],
          realData = block[1].split(",")[1],
          blob = b64toBlob(realData, contentType);
    }
    if ($(".image_uploader_value_2").val() != "") { 
      var ImageURL2 = $(".image_uploader_value_2").val(),
          blockS = ImageURL2.split(";"),
          contentTypeS = blockS[0].split(":")[1],
          realDataS = blockS[1].split(",")[1],
          blobS = b64toBlob(realDataS, contentTypeS);
    }
      
    var bottelImageURL = mapcanvas.toDataURL(), 
        bottleblock = bottelImageURL.split(";"),
        bottelcontentType = bottleblock[0].split(":")[1],
        bottelrealData = bottleblock[1].split(",")[1],
        bottelblob = b64toBlob(bottelrealData, bottelcontentType),
        data = new FormData();
  
        data.append('sections', 'cart-drawer');
        data.append("id", $(this).data('variant-id'));
        data.append("quantity", Number($(".qty_input").val()));
        data.append("properties[Name]", $("#nameinput").val());
        data.append("properties[Unique Name]", $(".all_unique_input").val());
        data.append("properties[Original Image 1]", blob);
        data.append("properties[Original Image 2]", blobS);
        data.append("properties[Preview Image]", bottelblob);
        data.append("properties[Style]", $(".customize_main_wrapper.customize_product_wrapper .leftside_main_step_container .style-btn.active").attr("data-label"));
        data.append("properties[Background color]", backgroundColor);
        data.append("properties[Text color]", textColor);
    
      $(this).attr("disabled","disabled");
      var $this = $(this);
      $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: data,
        contentType:false,
        processData:false,
        cache: false,
        success: function (item) {
          $this.removeAttr("disabled","disabled");
          document.dispatchEvent(
            new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
          );
          document.querySelector('.js-cart-drawer').open();
        },
        error: function (error) {
          $this.next(".error_message").html(`<p>${error.responseJSON.description}</p>`);
          $this.removeAttr("disabled","disabled");
          setTimeout(() => {
            $this.next(".error_message").html("");
          },5000)
        }
      });
  });


// ===================== form submit =====================

  const fileInputform = document.querySelector(".image_uploader_form");

  function handleFileUploadForm () {
    const fileReader = new FileReader();
    var fileInput = this.files[0];
    if (fileInput){
      fileReader.readAsDataURL(this.files[0])
      fileReader.onload = (e) => {
        const dataURL = e.target.result;
        $(".image_holder_form").val(dataURL);        
      }
    }
  }

  fileInputform.addEventListener('change', handleFileUploadForm);
  // $(".image_uploader_form").parents(".form_image_uploader_wrapper").addClass("loading-active");
  // $(".image_uploader_form").attr("disabled");


  $(".customize_main_wrapper.customize_product_wrapper .customize_map_wrapper .left_sidebar .form_popup form .form_submit").click(function(e) {

    var form = $(e.target).parents($("form.cm-bottel")),
        ImageURL = $(".image_holder_form").val(),
        block = ImageURL.split(";"),
        contentType = block[0].split(":")[1],
        realData = block[1].split(",")[1],
        blob = b64toBlob(realData, contentType),
        data = new FormData();
  
        data.append("id", 40493016317975);
        data.append("quantity", 1);
        data.append("properties[Logo_image]", blob);
    
      $(this).html('<div class="loading-spinner loading-spinner--in-btn"></div>').attr("disabled","disabled");
      $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: data,
        contentType:false,
        processData:false,
        cache: false,
        success: function (item) {
          $(e.target).parents("form.cm-bottel").find(".image_holder_form").val(item.properties.Logo_image);
          $.ajax({
            type: 'POST', 
            url: '/cart/change.js',
            dataType: 'json', 
            data: {id: 40493016317975,quantity:0},
            success: function (item) {
              $(e.target).html($(e.target).attr("data-label")).removeAttr("disabled","disabled");
              $(e.target).parents($("form.cm-bottel")).submit();
            }
          })
        }
      });
  });